"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfig = void 0;
const env_1 = require("./env");
/**
 * Creates a config for a UI
 * @param configByEnv - A record of variables for each Env
 * @returns Config
 */
function createConfig(configByEnv, options) {
    const env = (0, env_1.getEnv)(options === null || options === void 0 ? void 0 : options.systemEnvVariables);
    const config = configByEnv[env];
    return {
        get: (name, defaultValue = '') => {
            if (!config) {
                throw new Error(`Could not find a config for env=${env}`);
            }
            return name in config ? config[name] : defaultValue;
        },
        is: (_env) => env === _env,
        getEnv: () => env,
    };
}
exports.createConfig = createConfig;
//# sourceMappingURL=config.js.map